import { NyuDataProperties, NyuSeriesProperties } from '../../../shared/types'
import useGlobalState from './useGlobalState'

export function canActivateHighContrastMode(
    dataProperties: NyuDataProperties,
    seriesProperties: NyuSeriesProperties
): boolean {
    const isLineChart =
        dataProperties.chartType === 'line' || !dataProperties.chartType
    const isBarChart = dataProperties.chartType === 'bar'
    const isStacked = seriesProperties.some((series) => series.stack)

    // For stacked bar charts, check if any series has a special shape
    // If so, high contrast mode should be disabled as shapes provide visual distinction
    if (isBarChart && isStacked) {
        const hasShapeInAnyStack = seriesProperties.some(
            (series) => series.barShapeType
        )
        if (hasShapeInAnyStack) {
            return false
        }
    }

    // High contrast mode can be activated for:
    // 1. Line charts (shapes for lines)
    // 2. Stacked bar charts without special shapes (letters for segments)
    return isLineChart || (isBarChart && isStacked)
}

export function useHighContrastDisplay(
    dataProperties: NyuDataProperties,
    seriesProperties: NyuSeriesProperties
) {
    const highContrastMode = useGlobalState((state) => state.highContrastMode)
    const canActivate = canActivateHighContrastMode(
        dataProperties,
        seriesProperties
    )

    const isLineChart =
        dataProperties.chartType === 'line' || !dataProperties.chartType
    const isBarChart = dataProperties.chartType === 'bar'
    const isStacked = seriesProperties.some((series) => series.stack)

    return {
        highContrastMode: highContrastMode && canActivate,
        showShapes: highContrastMode && canActivate && isLineChart,
        showLetters: highContrastMode && canActivate && isBarChart && isStacked,
        isLineChart,
        isBarChart,
        canActivate,
    }
}
